jQuery.feature_import("js-client-diet-settings",
    () => require("./ClientDietSettings.tsx"),
    mod => mod.feature_js_client_diet_settings
);